import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(`${API}/auth/login`, formData);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('admin_token', res.data.token);
      localStorage.setItem('admin_user', JSON.stringify(res.data.admin));
      toast.success('Connexion réussie !');
      navigate('/intranet');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen hero-gradient flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl p-8 shadow-xl border border-slate-100">
          <div className="text-center mb-8">
            <img
              src="https://customer-assets.emergentagent.com/job_techkids-learn-1/artifacts/2efozgua_471419268_122203530860204093_7119326466186742520_n-2.jpg"
              alt="LudoTech Robotics"
              className="h-16 w-auto mx-auto mb-4"
            />
            <h1 className="font-heading text-3xl font-bold text-slate-900 mb-2">Intranet</h1>
            <p className="text-slate-600">Accès formateurs et administrateurs</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="text-sm font-semibold text-slate-700 mb-2 block">
                Email
              </Label>
              <Input
                id="email"
                type="email"
                data-testid="input-email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="rounded-xl border-slate-200 bg-slate-50 px-4 py-3"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-sm font-semibold text-slate-700 mb-2 block">
                Mot de passe
              </Label>
              <Input
                id="password"
                type="password"
                data-testid="input-password"
                required
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="rounded-xl border-slate-200 bg-slate-50 px-4 py-3"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="submit-login"
              className="w-full rounded-full bg-primary text-white px-8 py-6 text-lg font-bold hover:bg-primary/90 transition-all"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
